<template>
  <div class="pricing-page">
    <section class="hero is-fullheight">
      <div class="hero-body">
        <div class="container has-text-centered -adjust-content-up">
          <img
            src="../assets/img/illustrations/08.png"
            class="-image has-margin-bottom-20"
          />
          <h1 class="title has-margin-bottom-40">Page Not Found.</h1>
          <p class="subtitle">
            Sorry! The page you're looking for does not exist.
          </p>
          <router-link to="/">
            <b-button type="is-light" icon-left="keyboard-return">
              Return To Site
            </b-button>
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "pageNotFound"
};
</script>

<style scoped lang="scss">
.-image {
  max-height: 256px;
  width: auto;
}

@media only screen and (max-width: 600px) {
  .-image {
    max-height: 192px;
    width: auto;
  }
}

.-adjust-content-up {
  margin-top: -120px;
}
</style>
